.eds-divider {
  background-color: var(--eds--color--bg-muted-default);
  flex: none;
}

/* Variants */

/* Horizontal */
.eds-divider--direction-horizontal {
  height: var(--eds--size-1);
  width: 100%;
}

/* Vertical */
.eds-divider--direction-vertical {
  align-self: stretch;
  width: var(--eds--size-1);
}
